import React, { Component } from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'
import _ from 'lodash'

import { FormattedMessage } from 'react-intl'

import Role from '../../Role'

import { LOCALE_PREFIX_ROLE } from './constants'

import acl from '../../../../../../../../../services/acl'

import config from '../../../../../../../../../config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'
import hocConnect from './hocConnect'

import './style.scss'

@hocBlock(config.modules.report.key, { levelReload: true })
@hocConnect
@acl
export default class RolesInCompanies extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object.isRequired,
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true
        if (!_.isEqual(this.props.customData, nextProps.customData)) return true

        return false
    }

    render() {
        const { id, data, level, module, block, customData } = this.props

        return (
            <div className={cx('block-roles-in-companies')}>
                <Role
                    module={module}
                    block={block}
                    id={id}
                    level={level}
                    data={data}
                    customData={customData}
                    mainId={id}
                    translates={{
                        today: <FormattedMessage id={`${LOCALE_PREFIX_ROLE}.today`} />,
                        activeSum: <FormattedMessage id={`${LOCALE_PREFIX_ROLE}.activeSum`} />,
                        from: <FormattedMessage id={`${LOCALE_PREFIX_ROLE}.from`} />,
                        to: <FormattedMessage id={`${LOCALE_PREFIX_ROLE}.to`} />,
                        birthDateLabel: <FormattedMessage id={`${LOCALE_PREFIX_ROLE}.birthDateLabel`} />,
                        activeCompaniesLabel: (
                            <FormattedMessage
                                id={`${LOCALE_PREFIX_ROLE}.activeCompaniesLabel`}
                                values={{ br: <br /> }}
                            />
                        ),
                        activeRolesLabel: (
                            <FormattedMessage id={`${LOCALE_PREFIX_ROLE}.activeRolesLabel`} values={{ br: <br /> }} />
                        ),
                        noData: <FormattedMessage id={`${LOCALE_PREFIX_ROLE}.noData`} />,
                        showAll: <FormattedMessage id={`${LOCALE_PREFIX_ROLE}.showAll`} />,
                        hideAll: <FormattedMessage id={`${LOCALE_PREFIX_ROLE}.hideAll`} />,
                    }}
                />
            </div>
        )
    }
}
